// extracted by mini-css-extract-plugin
export default {"region":"Stepper_region__pKKp6"};